/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import { omitBy, isFunction, isEmpty } from "lodash";
import { Model } from "./Model";
import { RawResource } from "./RawResource";

/**
 *
 */
export class Resource<T extends Model> {

    constructor(private type: string, private model: T) { }

    /**
     *
     */
    getType(): string {
        return this.type;
    }

    /**
     *
     */
    getModel(): T {
        return this.model;
    }

    /**
     *
     */
    getId(): string {
        return this.model.id;
    }

    /**
     *
     */
    getAttributes(): {[name: string]: any} {
        if ( this.model.getAttributes ) {
            return this.model.getAttributes();
        } else {
            return omitBy(this.model as any, (value, key) =>
                key === "id" ||
                key.startsWith("_") ||
                isFunction(value)
            ) as any;
        }
    }

    /**
     *
     */
    toRaw(): RawResource {
        const raw: RawResource = {
            type: this.getType(),
            id: this.getId()
        };

        const attributes = this.getAttributes();
        if ( !isEmpty(attributes) ) {
            raw.attributes = attributes;
        }

        return raw;
    }
}



// WEBPACK FOOTER //
// ./src/utils/json-api/Resource.ts